import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const ApprovalsStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Approvals Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
